import { useCallback, useState } from "react";
import { getPlaybookParams } from "@/lib/api";

export function usePlaybookParams() {
  const [paramNames, setParamNames] = useState<string[]>([]);
  const [paramValues, setParamValues] = useState<Record<string, string>>({});

  const resetParams = useCallback((playbookId: string) => {
    setParamValues({});
    if (playbookId) {
      getPlaybookParams(playbookId).then((r) => setParamNames(r.params));
    } else {
      setParamNames([]);
    }
  }, []);

  const params = paramNames.length > 0 ? paramValues : undefined;

  return { paramNames, paramValues, setParamValues, resetParams, params };
}
